import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { CitiesTypes } from 'store/modules/online_search_store/types';
import MapWithControls from '../map_with_controls';

interface InnerBoundTypes {
  lat: Number | undefined;
  lng: Number | undefined;
}

interface BoundsTypes {
  ne: InnerBoundTypes;
  sw: InnerBoundTypes;
}
interface ModalLocationProps {
  modalLocationOpened: boolean;
  setModalLocationOpened: React.Dispatch<React.SetStateAction<boolean>>;
  setAddressSelected: React.Dispatch<React.SetStateAction<string>>;
  addressSelected: string;
  bounds: BoundsTypes;
  setBounds: React.Dispatch<React.SetStateAction<BoundsTypes>>;
  position: google.maps.LatLngLiteral | null;
  setPosition: React.Dispatch<React.SetStateAction<google.maps.LatLngLiteral | null>>;
  radius: number;
  setRadius: React.Dispatch<React.SetStateAction<number>>;
  setCitiesGeolocation: React.Dispatch<React.SetStateAction<Array<CitiesTypes>>>;
}

const ModalLocation = (props: ModalLocationProps) => {
  const {
    modalLocationOpened,
    setModalLocationOpened,
    setAddressSelected,
    addressSelected,
    bounds,
    setBounds,
    position,
    setPosition,
    radius,
    setRadius,
    setCitiesGeolocation,
  } = props;

  return (
    <Modal show={modalLocationOpened} size="lg" onHide={() => setModalLocationOpened(false)}>
      <>
        <div className="modal-header">
          <h6 className="modal-title" id="modalLabel">
            FIltro por endereço
          </h6>
          <button
            aria-label="Close"
            className="close"
            type="button"
            onClick={() => setModalLocationOpened(false)}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <MapWithControls
          setModalLocationOpened={setModalLocationOpened}
          setAddressSelected={setAddressSelected}
          addressSelected={addressSelected}
          bounds={bounds}
          setBounds={setBounds}
          position={position}
          setPosition={setPosition}
          radius={radius}
          setRadius={setRadius}
          setCitiesGeolocation={setCitiesGeolocation}
        />
      </>
    </Modal>
  );
};

export default ModalLocation;
